import * as React from 'react';

import type {GetPrimaryContextDocument_primaryContextDocument_aiSuggestions as AiSuggestionType} from 'nutshell-graphql-types';

import {Stack} from '../layout/stack/stack';
import {Body} from '../typography/body';

import {ChatNudges} from './chat-nudges';

import styles from './chat-preview.module.css';

type Props = {
    conversationStarter: string;
    secondaryColor: string;
    chatbotName: string;
    chatbotIcon: React.ComponentType<any> | null | undefined;
    suggestions: Array<AiSuggestionType>;
    isLoadingSuggestions: boolean;
};

export function AppearanceContent(props: Props) {
    const Icon = props.chatbotIcon;

    return (
        <Stack spacing={8}>
            {/* @ts-expect-error */}
            <Stack isHorizontal={true} spacing={6} alignCenter={true}>
                {Icon ? <Icon size={14} alignCenter={true} /> : undefined}
                <Body size='mini'>{props.chatbotName}</Body>
            </Stack>
            <div className={styles['chat-bubble--outgoing']}>{props.conversationStarter}</div>
            <ChatNudges
                secondaryColor={props.secondaryColor}
                suggestions={props.suggestions}
                isLoading={props.isLoadingSuggestions}
            />
        </Stack>
    );
}
